// What kind of agent a roster entry is, for the surfaces that list agents.
//
//   standard  a team member: channels, a desktop, mail, todos, handoffs
//   family    a child's helper (restricted, the parent reads every chat)
//   subagent  a subagent blueprint: an adviser the agents SPAWN (Ray Dalio,
//             a research lead). No channel, no inbox, no desktop; it is
//             never assigned work directly. Its home is the Subagents page.
//
// Business surfaces (todos, handoffs, meeting follow-ups, channel and mail
// pickers) offer teammates only. Knowledge and integration scope pickers
// still offer blueprints: that is how one gets a corpus or an integration.

interface HasKind {
  kind?: string | null;
}

/** A subagent blueprint (manifest `kind: subagent`). */
export function isBlueprint(agent: HasKind | null | undefined): boolean {
  return agent?.kind === "subagent";
}

/** Someone you hand work to: not a family helper, not a subagent blueprint. */
export function isTeammate(agent: HasKind | null | undefined): boolean {
  return !agent?.kind || agent.kind === "standard";
}
